export class DetailsFormModel {
  public firstName: string = '';
  public lastName: string = '';
  public email: string = '';
  public phone: string = '';
  public plain_password: string;
  public passwordConfirm: string;
  public birthday: any = new Date(1900, 0, 1);
  public receiveSpecialOfferEmail: boolean;
  public receiveSpecialOfferSms: boolean;
  public receiveSpecialOfferPush: boolean;
}

export class DetailsModel {
  public currentBookingOptions: any = null; // current data of widget
  public widgetIdForRouting: string = null; // widget id
  public currentInfoData: any = null;
  public changeDetectorRefTimeout: any = null;

  constructor(
    currentBookingOptions: any,
    widgetIdForRouting: string
  ) {
    this.currentBookingOptions = currentBookingOptions;
    this.widgetIdForRouting = widgetIdForRouting;
  }
}

export class DetailsStoreModel {
  public subscribtion: any = {
    booking$: null,
    info$: null,
    registration$: null
  };
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/details/details.model.ts